import { ReactNode, Suspense } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from './config'

interface I18nProviderProps {
  children: ReactNode
}

// Loading component for Suspense fallback
function I18nLoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
    </div>
  )
}

export function I18nProvider({ children }: I18nProviderProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<I18nLoadingFallback />}>
        {children}
      </Suspense>
    </I18nextProvider>
  )
}